import { openSnack } from '../redux/slices/toast';

export const toast = ({message, type}, dispatch) => {
  dispatch(openSnack({ message, type }));
};
